module.exports = __webpack_public_path__ + "media/images/shapes/curves/curve-2-429d849f5f4d6ab996422a9ee4584ec279c6bb6c17ca0f2885e59c30e7d8d13c.svg";